<template>
  <div class=question-wrapper>
    <div class="question">
      <div class="question-info">
        <div class="question-title">
          {{ question.title }}
        </div>
        <div class="question-content" v-html="question.content">
        </div>
      </div>
      <div class="question-actions" v-if="!showCreateForm">
        <div class="question-action" @click="openForm">
          Agregar
        </div>
        <div class="question-action" @click="deleteQuestion(question.id)" >
          Eliminar
        </div>
      </div>
    </div>
    <div class="question-form" v-if="showCreateForm">
      <div class="form-header">
        Nueva pregunta
        <div class="close" @click="showCreateForm=false" >X</div>
      </div>
      <div class="label">
        <div class="label-text">
          Pregunta:
        </div>
        <BaseInput v-model="data.title" />
      </div>
      <div class="label">
        <div class="label-text">
          Respuesta:
        </div>
        <BaseInput v-model="data.content" />
      </div>
      <div class="button-wrapper">
        <div class="button" @click="saveNewQuestion">Guardar</div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import BaseInput from '@/components/base/BaseInput.vue';

const { mapActions } = createNamespacedHelpers('support');
export default {
  data() {
    return {
      showCreateForm: false,
      data: {
        title: '',
        content: '',
        nextId: null,
      },
    };
  },
  props: {
    question: Object,
  },
  components: {
    BaseInput,
  },
  methods: {
    openForm() {
      this.showCreateForm = true;
    },
    async saveNewQuestion() {
      await this.createQuestion({
        previousId: this.question.id,
        nextId: this.question.nextId,
        section: this.question.section,
        title: this.data.title,
        content: this.data.content,
      });
      this.data = {
        title: '',
        content: '',
        nextId: null,
      };
      this.showCreateForm = false;
    },
    ...mapActions([
      'createQuestion',
      'deleteQuestion',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.question-wrapper {
  width: 100%;
}
.question {
  width: 100%;
  background-color: white;
  border: 1px solid rgb(223, 223, 223);
  margin-top: 20px;
  padding: 12px 20px;
  display: flex;
}
.question-title {
  font-weight: bold;
  margin-bottom: 8px;
}
.question-info {
  width: 80%;
  padding-right: 16px;
  line-height: 20px;
}
.question-actions {
  width: 20%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.question-action {
  cursor: pointer;
  color: #3479e9;
}
.question-form {
  background-color: white;
  border: 1px solid rgb(223, 223, 223);
  margin-top: 20px;
  padding: 12px 20px;
  display: flex;
  flex-direction: column;
}
.label {
  width: 100%;
  display: flex;
  margin-top: 14px;
  align-items: center;
}
.label-text {
  margin-right: 18px;
}
.form-header {
  width: 100%;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
}
.close {
  cursor: pointer;
}
.button-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}
.button {
  background-color: #3479e9;
  color: white;
  padding: 12px 20px;
  display: flex;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
}
@media only screen and (max-width: 750px) {
  .question {
    flex-direction: column;
  }
  .question-info {
    width: 100%;
  }
  .question-actions {
    width: 100%;
    justify-content: flex-start;
    margin-top: 16px;
  }
  .question-action {
    margin-right: 15px;
  }
}
</style>
